module.exports = __webpack_public_path__ + "static/media/activityDetails.5ad5de02.png";